export default "__VITE_ASSET__c2def83f__"